module.exports = __webpack_public_path__ + "static/media/paver_turquoise.81762faf.svg";